import {Cureus} from '../Cureus';

Cureus.AdminInsideCureusArticles = {};

//= require_tree ./AdminInsideCureusArticles
